import { Button, Card, CardActions, CardContent, Typography } from "@mui/material";
import { Asset, AssetTypeToString } from "../types/types";

export interface AssetCardProps {
  asset: Asset;
  onDelete: (assetId: string) => void;
  onDownload: (asset: Asset) => void;
}

export const AssetCard = (props: AssetCardProps) => {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <CardContent>
        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
          {AssetTypeToString(props.asset.type)}
        </Typography>
        <Typography variant="body2"
          sx={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}
        >
          {props.asset.name}
        </Typography>
        {props.asset.size && props.asset.size > 0 && (
          <Typography variant="body2"
            sx={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
            }}
          >
            {(props.asset.size / (1024 * 1024)).toFixed(2)}MB
          </Typography>
        )}
      </CardContent>
      <CardActions>
        <Button
          color="error"
          size="small"
          onClick={async () => {
            await props.onDelete(props.asset.id);
          }}
        >Delete</Button>
        <Button
          size="small"
          onClick={async () => {
            await props.onDownload(props.asset);
          }}
        >Download (zip)</Button>
      </CardActions>
    </Card>
  );
}